module.exports = __webpack_public_path__ + "img/phone-call.2bb9b9a7.svg";